import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = { class: "float-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva entrada", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva salida", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "fw-300" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_18 = { class: "panel-container" }
const _hoisted_19 = { class: "panel-content" }
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_kardex_editar_entrada_salida_component = _resolveComponent("kardex-editar-entrada-salida-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nueva entrada",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.nuevaEntrada && $setup.nuevaEntrada(...args)))
                }, _hoisted_12),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success btn-sm mr-2",
                  title: "Nueva entrada",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.nuevaSalida && $setup.nuevaSalida(...args)))
                }, _hoisted_15)
              ]),
              _createElementVNode("h2", null, [
                _createTextVNode(" Listado de"),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "texto-buscar",
                          name: "texto-buscar",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.textoFiltro) = $event)),
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.filtrarInformacion && $setup.filtrarInformacion(...args)))
                        }, null, 544), [
                          [_vModelText, $setup.textoFiltro]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_EasyDataTable, {
                  headers: $setup.headers,
                  items: $setup.kardexsFiltrados,
                  "border-cell": "",
                  alternating: "",
                  "buttons-pagination": ""
                }, {
                  "item-saldo_inicial": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_25, _toDisplayString($setup.numeral(item.saldo_inicial).format('0,0.00')), 1)
                  ]),
                  "item-entradas": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_26, _toDisplayString($setup.numeral(item.entradas).format('0,0.00')), 1)
                  ]),
                  "item-salidas": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_27, _toDisplayString($setup.numeral(item.salidas).format('0,0.00')), 1)
                  ]),
                  "item-saldo": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_28, _toDisplayString($setup.numeral(item.saldo).format('0,0.00')), 1)
                  ]),
                  _: 1
                }, 8, ["headers", "items"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_29,
    _createVNode(_component_kardex_editar_entrada_salida_component, {
      ref: "kardexEditarEntradaSalidaComponentRef",
      onCerrarKardexEditarEntradaSalidaComponent: $setup.cerrarKardexEditarEntradaSalidaComponentEmit
    }, null, 8, ["onCerrarKardexEditarEntradaSalidaComponent"])
  ], 64))
}